import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { Card } from '@thd-olt-component-react/core-ui';
import { SpecialBuyBanner } from '@thd-olt-component-react/special-buy-banner';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedSpecialBuyOfTheDay({
  SCROLL_BUFFER,
  PLACEHOLDER,
}) {
  return function SpecialBuyOfTheDay() {
    return (
      <QueryProvider cacheKey="sbotd">
        <Hydrator
          id="sbotd-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          placeholder={PLACEHOLDER}
        >
          <Card>
            <SpecialBuyBanner specialBuyType="sbotd" />
          </Card>
        </Hydrator>
      </QueryProvider>
    );
  };
}
